import { FILTER_TYPES } from 'components/FilterPod';
import { STATUS_CODE_OPTIONS, INSTALLMENT_STATUS_CODE } from '../../constants/Options';

const filters = (currencyText) => [
  {
    title: 'محدوده تاریخ ایجاد تسهیلات',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'creationDateRange',
    query: {
      start: 'creationDateFrom',
      end: 'creationDateTo',
    },
    id: {
      start: 5,
      end: 6,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'محدوده‌ مبلغ تسهیلات',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountRange',
    id: {
      start: 1650,
      end: 1651,
    },
    value: {
      start: null,
      end: null,
    },
    query: {
      start: 'fromAmount',
      end: 'toAmount',
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },

  {
    title: 'شناسه تسهیلات',
    label: 'شناسه تسهیلات',
    keyName: 'id',
    query: 'id',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'وضعیت تسهیلات',
    label: 'وضعیت تسهیلات',
    keyName: 'statusCode',
    query: 'statusCode',
    id: 7,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_CODE_OPTIONS,
    },
  },
  {
    title: 'وضعیت قسط',
    label: 'وضعیت قسط',
    keyName: 'installmentStatusCode',
    query: 'installmentStatusCode',
    id: 7,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: INSTALLMENT_STATUS_CODE,
    },
  },
];

export default filters;
